import React from "react";
import {
  ShowController,
  SimpleShowLayout,
  TextField,
  DateField
} from "react-admin";

import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import CloseIcon from "@material-ui/icons/Close";
import { TargetField, FullNameField } from "../../misc/customFields";

const showStyles = theme => ({
  root: {
    paddingTop: 40
  },
  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "1em"
  },
  form: {
    [theme.breakpoints.up("xs")]: {
      width: 400
    },
    [theme.breakpoints.down("xs")]: {
      width: "100vw",
      marginTop: -30
    }
  },
  inlineField: {
    display: "inline-block",
    width: "50%"
  }
});

const MainAuditShow = ({ classes, onCancel, ...props }) => (
  <ShowController {...props}>
    {controllerProps =>
      controllerProps.record ? (
        <div className={classes.root}>
          <div className={classes.title}>
            <Typography variant="title">
              Audit {controllerProps.record.entity} #{" "}
              {controllerProps.record.id}
            </Typography>
            <IconButton onClick={onCancel}>
              <CloseIcon />
            </IconButton>
          </div>
          <SimpleShowLayout
            className={classes.form}
            basePath={controllerProps.basePath}
            record={controllerProps.record}
            version={controllerProps.version}
            redirect="list"
            resource="main_audit"
          >
            <TextField source="note" />
            <TargetField />
            <TextField source="id" className={classes.inlineField} />
            <TextField source="operation" className={classes.inlineField} />
            <TextField source="entity" className={classes.inlineField} />
            <TextField
              source="db_id"
              label="Entity Id"
              className={classes.inlineField}
            />
            <DateField
              source="created"
              showTime
              className={classes.inlineField}
            />
            <DateField
              source="updated"
              showTime
              className={classes.inlineField}
            />
          </SimpleShowLayout>
        </div>
      ) : null
    }
  </ShowController>
);

export default withStyles(showStyles)(MainAuditShow);
